<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="400px"
			center
			:append-to-body='true'
			@close="closeWin"
      title="清空党费"
			:visible.sync="dialogVisible">
      <div class="month_list">
        <div class="month" 
        :class="{selectMonth: month.includes((`${year}/${index+1}`))}"
        v-for="(item,index) in 12" :key="index" @click="selectMonth(index+1)">
          {{index+1}}月
        </div>
      </div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeWin">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
  import { dwgl } from '@/axios'
  export default{
    data(){
      return{
        dialogVisible:false,
        month:[],
        id:"",
        year:new Date().getFullYear()
      }
    },
    methods: {
      closeWin(){
        this.dialogVisible = false
        this.month = []
      },
      openWin(id,year){
        this.id = id;
        if(year){
          this.year = year
        }
        this.dialogVisible = true
      },
      // 确定
      submit(){
        if(!!!this.month.length){
          this.$message.warning("请选择清除的月份")
        }else{
          dwgl.clearParties({
            id:this.id,
            jtime:this.month
          }).then(res => {
            if(res.code === 200){
              this.$message.success("清除成功")
              this.$emit('dataList')
              this.closeWin()
            }
          })
        }
      },
      selectMonth(month){
        if(!!!this.month.includes(`${this.year}/${month}`)){
          this.month.push(`${this.year}/${month}`)
        }else{
          this.month.splice(this.month.indexOf(`${this.year}/${month}`),1)
        }
        console.log(this.month)
      }
    },
  }
</script>

<style lang="scss">
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 500px;
		}
	}
  .month_list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .month{
      cursor: pointer;
      font-size: 16px;
      padding: 10px 20px;
      margin: 8px 8px 0 0;
      &:hover{
        color: #fff;
        background: #bb0000;
      }
    }
  }
  .selectMonth{
    color: #fff;
    background: #bb0000;
  }
</style>
